import type { CurrentUser } from 'src/AuthContext';
import { isProd } from 'src/globalSettings';

const rewriteExcludeUsers = ['nevil@hexacoder.com', 'ajay@hexacoder.com'];
export const handleRewriteUser = (user: CurrentUser) => {
  const { accountName, email, accountType } = user;
  // const isRewriteUser = accountType !== ACCOUNT_TYPE.MULTIFAMILY;
  // const isPro = accountName === 'PRO Department';
  const isExcludedUser = rewriteExcludeUsers.includes(email.toLowerCase());

  if (isExcludedUser) {
    return false;
  }
  return true;
};
export const rewriteUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'studio-test.modularclosets-apps.com') {
    return 'https://studio-test.modularclosets-apps.com';
  }

  if (hostname === 'studio-qa.modularclosets-apps.com') {
    return 'https://studio-qa.modularclosets-apps.com';
  }

  const url = isProd
    ? 'https://studio-v2.modularclosets-apps.com'
    : 'https://rewrite-staging.modularclosets-apps.com';
  return url;
};
export const v1Url = () => {
  const hostname = window.location.hostname;

  if (hostname === 'studio-test.modularclosets-apps.com') {
    return 'https://studio-test.modularclosets-apps.com';
  }
  const url = isProd
    ? 'https://studio.modularclosets-apps.com'
    : 'https://modularstudio.modularclosets-apps.com';
  return url;
};
export const handleRedirectUrl = (user: CurrentUser) => {
  const isRewriteUser = handleRewriteUser(user);
  if (isRewriteUser) {
    const url = rewriteUrl();
    return url;
  }
  return null;
};

/**
 * Translates the wall measurements Salesforce puts on the link into the
 * `dims` parameter the design tool reads.
 *
 * Salesforce carries five walls; the tool builds a rectangle, so it takes the
 * back wall as the width, the left wall as the depth, and the two stubs either
 * side of the doorway. Wall D (the right wall) is the mirror of Wall B and is
 * not used.
 *
 *   wallA -> e   "Left of door"  on the lead form
 *   wallB -> b   depth
 *   wallC -> c   width of the door wall
 *   wallE -> a   "Right of door" on the lead form
 *
 * A and E are crossed deliberately. The lead form's own diagrams
 * (left-of-door.webp / right-of-door.webp) are plan views with the doorway on
 * the near wall, and they place "left of door" on the left of the drawing. The
 * tool's plan view labels `e` the Left Return Wall and `a` the Right. Mapping
 * A->a would deliver every room as its own mirror image.
 *
 * Returns an empty string unless all four are present and positive, so a
 * partly filled opportunity produces an ordinary link rather than a bad room.
 */
export const buildDimsParam = (searchParams: URLSearchParams): string => {
  const read = (key: string) => {
    const raw = searchParams.get(key);
    if (!raw) return null;
    const value = Number(raw.replace(/["″]/g, '').trim());
    return Number.isFinite(value) && value > 0 ? String(value) : null;
  };

  // Crossed on purpose -- see the note above.
  const e = read('wallA');
  const b = read('wallB');
  const c = read('wallC');
  const a = read('wallE');
  if (!a || !b || !c || !e) return '';

  const doorType = searchParams.get('doorType')?.trim().toLowerCase();
  const doorSwing = searchParams.get('doorSwing')?.trim().toLowerCase();

  const dims = {
    a,
    b,
    c,
    e,
    ...(doorType && { doortype: doorType }),
    ...(doorSwing && { door_swing: doorSwing }),
  };

  return `&dims=${encodeURIComponent(JSON.stringify(dims))}`;
};
